import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck, X } from "lucide-react";

export const CookieConsent: React.FC = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("wildfoerster_consent");
    if (!consent) {
      const timer = setTimeout(() => setShowConsent(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("wildfoerster_consent", "granted");
    setShowConsent(false);
    window.location.reload(); // Reload to activate TikTok scripts
  };

  const handleDecline = () => {
    localStorage.setItem("wildfoerster_consent", "denied");
    setShowConsent(false);
  };

  return (
    <AnimatePresence>
      {showConsent && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:max-w-md z-[100]"
        >
          <div className="bg-zinc-900 border border-[#cfc297]/30 p-8 rounded-2xl shadow-2xl backdrop-blur-xl">
            <div className="flex items-start gap-4">
              <div className="bg-[#cfc297]/10 p-3 rounded-full">
                <ShieldCheck className="w-6 h-6 text-[#cfc297]" />
              </div>
              <div className="flex-1">
                <h3 className="text-white font-black uppercase tracking-tighter text-xl mb-2">
                  Privatsphäre <span className="text-[#cfc297]">zuerst</span>
                </h3>
                <p className="text-white/60 text-xs leading-relaxed mb-6 uppercase tracking-wider">
                  Um unser TikTok-Showcase und eingebettete Medien anzuzeigen, benötigen wir Ihre Zustimmung zum Laden externer Inhalte.
                </p>
                <div className="flex flex-col gap-3">
                  <button
                    onClick={handleAccept}
                    className="w-full py-4 bg-[#cfc297] text-black text-[10px] font-black uppercase tracking-widest rounded-full hover:bg-white transition-all duration-300"
                  >
                    Alle akzeptieren
                  </button>
                  <button
                    onClick={handleDecline}
                    className="w-full py-4 bg-white/5 text-white/40 text-[10px] font-black uppercase tracking-widest rounded-full hover:bg-white/10 transition-all duration-300"
                  >
                    Nur Notwendige
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
